module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._v("Life Changing Books in conjunction with Power Play Media"), _c('br'), _vm._v("Published by Life Changing Books"), _c('br'), _vm._v("P.O. Box 423 Brandywine, MD 20613")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("This novel is a work of fiction. Any references to real people, events, establishments, or locales are intended only to give the fiction a sense of reality and authenticity. Other names, characters, and incidents occurring in the work are either the product of the author’s imagination or are used fictitiously, as are those fictionalized events and incidents that involve real persons. Any character that happens to share the name of a person who is an acquaintance of the author, past or present, is purely coincidental and is in no way intended to be an actual account involving that person.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data;"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.lifechangingbooks.net",
      "target": "_blank"
    }
  }, [_vm._v("www.lifechangingbooks.net")]), _c('br'), _c('br'), _vm._v("Ebook: 978-1625171313"), _c('br'), _vm._v("13 Digit: 978-1934230350"), _c('br'), _vm._v("10 Digit: 1934230359"), _c('br'), _c('br'), _vm._v("Copyright © 2011"), _c('br'), _vm._v("All rights reserved, including the rights to reproduce this book or portions thereof in any form whatsoever.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-625cbee7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copy.vue
// module id = 60
// module chunks = 0